import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/booking/orderById.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var getOrderById = (_0) => __async(void 0, [_0], function* ({ orderId, type, lang, encoded }) {
  try {
    const lan = getLocaleOnly(lang);
    const orderType = type === "bundle" ? "bundle" : type === "season" ? "season" : "event";
    let url = `/order/${orderId}/${orderType}?lang=${lan}`;
    if (encoded) {
      url += "&wbk_session=yes";
    }
    const data = yield fetchClient({ url });
    if (orderType === "season") {
      return __spreadProps(__spreadValues({}, data.data), {
        summary: data.data.summary.map((item) => __spreadProps(__spreadValues({}, item), {
          event: item.season || item.event,
          tickets_details: item.tickets_details.map((t) => __spreadProps(__spreadValues({}, t), {
            event_ticket_id: t.season_ticket_id || t.event_ticket_id,
            event_ticket_title: t.season_ticket_title || t.event_ticket_title,
            event_ticket_title_ar: t.season_ticket_title_ar || t.event_ticket_title_ar,
            event_ticket_title_en: t.season_ticket_title_en || t.event_ticket_title_en
          })),
          isSeason: !!item.season
        }))
      });
    }
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getOrderByIdException",
      context: { extra: { orderId } }
    });
  }
});
var getHyExperienceOrderById = (_0) => __async(void 0, [_0], function* ({ orderId, lang }) {
  try {
    const lan = getLocaleOnly(lang);
    const url = `/halayalla/booking-detail/${orderId}?lang=${lan}`;
    const data = yield fetchClient({
      url,
      options: { method: "POST", body: JSON.stringify({ lang: lan }) }
    });
    return hyExperienceToWbkAdapter(data.data);
  } catch (error) {
    throw new Exception({
      error,
      name: "getHyExperienceOrderByIdException",
      context: { extra: { orderId } }
    });
  }
});
var hyExperienceToWbkAdapter = (data) => {
  var _a, _b, _c;
  const latLng = data.venue_details.latlng.split(", ");
  return {
    order_id: data._id,
    booked_type: (_a = data.status) == null ? void 0 : _a.toLowerCase(),
    type: "experience",
    order_created_at: {
      date: data.created_at,
      timezone: "",
      timezone_type: 0
    },
    promo_code: ((_b = data.coupon) == null ? void 0 : _b.code) || "",
    user: {
      email: data.customer_email,
      name: data.customer_name,
      phone: data.customer_cell_number
    },
    total: {
      currency: data.currency,
      comission_amount: data.time_slots.reduce(
        (acc, item) => acc + item.facility.commission_per_slot,
        0
      ),
      discount_amount: ((_c = data.coupon) == null ? void 0 : _c.discounted_amount) || 0,
      sub_total: data.net_price,
      grand_total: data.total_price,
      vat_total: data.vat
    },
    summary: [
      {
        event: {
          _id: data.venue_id,
          title: data.product_name,
          address: data.venue_details.address,
          city: data.venue_details.city,
          venue_name: data.venue_details.name,
          start_date_time: Number(data.time_slots[0].time.from),
          end_date_time: Number(data.time_slots[0].time.to),
          has_timeslots: true,
          venue: { city: data.venue_details.city },
          location: { lat: latLng[0], lng: latLng[1] },
          poster: data.venue_details.image,
          slug: data.venue_details.slug,
          status: "",
          tags: []
        },
        tickets: data.time_slots.map((slot) => ({
          _id: slot.id,
          title: slot.facility.name,
          currency: data.currency,
          qty: +slot.num_of_people,
          row: slot.facility.name,
          seat: slot.facility.description,
          section: "",
          price: slot.price * +slot.num_of_people - slot.facility.vat_per_slot * +slot.num_of_people,
          vat: slot.facility.vat_per_slot * +slot.num_of_people,
          status: "active"
        })),
        // Not used
        tickets_details: []
      }
    ],
    transactions: [
      {
        amount: data.total_price,
        transaction_id: data.transaction_id,
        type: "payment_gateway"
      }
    ]
  };
};

export {
  getOrderById,
  getHyExperienceOrderById
};
//# sourceMappingURL=chunk-UJTIFYG5.mjs.map